module.exports = __webpack_public_path__ + "img/full7-min.d3405b12.png";